import React from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';

const SuccessStep = ({ onStartApplying }) => {
  return (
    <div className="success-celebration">
      <Icon name="CheckCircle2" size={80} className="success-icon" />
      <h1 className="success-title">Onboarding Complete!</h1>
      <p className="success-message">
        Your profile is ready. We'll start applying to matching job opportunities on your behalf.
      </p>

      <div className="max-w-md mx-auto space-y-4">
        <div className="p-6 bg-card rounded-lg border border-border text-left">
          <h3 className="text-lg font-semibold text-foreground mb-4">What happens next?</h3>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name="Search" size={16} className="text-primary" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">Job Matching</p>
                <p className="text-xs text-muted-foreground mt-1">
                  We'll continuously search for jobs matching your criteria
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name="Send" size={16} className="text-primary" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">Auto Applications</p>
                <p className="text-xs text-muted-foreground mt-1">
                  Your applications will be submitted automatically
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name="Bell" size={16} className="text-primary" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">Real-time Updates</p>
                <p className="text-xs text-muted-foreground mt-1">
                  Get notified about application status and responses
                </p>
              </div>
            </div>
          </div>
        </div>

        <Button
          variant="default"
          size="lg"
          fullWidth
          onClick={onStartApplying}
          iconName="Rocket"
          iconPosition="left"
        >
          Start Applying for Me
        </Button>

        <p className="text-xs text-muted-foreground text-center">
          You can modify your preferences anytime from your dashboard
        </p>
      </div>
    </div>
  );
};

export default SuccessStep;